"use client";

import styled from "styled-components";
import { sans as zoram, lineHeight, fontSize14, fontWeightNormal, fontWeightSemiBold, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
import { jsx as _jsx } from "react/jsx-runtime";
const Container4 = styled.div.withConfig({
  componentId: "sc-1u44evz-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, ({
  $emphasized
}) => $emphasized ? fontWeightSemiBold : fontWeightNormal, lineHeight, fontSize14, shared, fontWeightBold);

/**
 * `Text4` (Description) is used for text supportive to the primary text.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Text content
 * @param {boolean} [props.emphasized] - Whether the styles should display as emphasized
 * @param {React.ElementType} [props.renderAs] - HTML tag or custom React element to render as
 * @returns {React.ReactElement} The Text4 component
 */
const Text4 = ({
  children,
  emphasized = false,
  renderAs = "div",
  ...props
}) => /*#__PURE__*/_jsx(Container4, {
  $emphasized: emphasized,
  as: renderAs,
  ...props,
  children: children
});
Text4.displayName = "Text4";
export default Text4;